import React, { useState, useMemo, useCallback } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from "~/ui/styled"
import { useSafeAreaInsets } from "~/ui/safe-area"
import { useFormik } from "formik"
import * as Yup from "yup";
import { ColumnFlex, CenterFlex, Text, Button } from "~components/El"
import { SearchBar } from "~components/SearchBar"
import { MultiLineTextField } from "~components/InputField"
import ContactListItem from "~/components/contact-list/components/contact-list-item"
import { FlatList } from "~widgets/flat-list"
import { GroupAssistantScreenProps } from "./types"
import { useStores } from "~models"


const Container = styled.View`
  flex: 1;
  padding: 10px 12px;
`
const GroupAssistant: React.FC<GroupAssistantScreenProps> = ({ route }) => {
    const theme = useTheme()
    const insets = useSafeAreaInsets()
    const { contactStore } = useStores()
    const [searchText, setSearchText] = useState("")
    const [loading, setLoading] = useState(false)
    const [selecteds, setSelecteds] = useState([])
    const data = contactStore?.getContactList() || []
    const formik = useFormik({
        initialValues: {
            remark: ""
        },
        validationSchema: () =>  Yup.object().shape({
            remark: Yup.string().required("请输入群发消息内容")
        }),
        onSubmit: (values) => {
            // console.log("提交成功", values);
        },
    });
    const { values, errors, touched, setFieldValue, handleSubmit } = formik;

    const isActive = useMemo(() => {
        return Boolean(values.remark) && selecteds.length > 0;
    }, [values.remark, selecteds.length]);

    const onItemClick = useCallback((contact) => {
      if (selecteds.find((x) => x === contact.id)) {
        setSelecteds(selecteds.filter((x) => x !== contact.id))
      } else {
        setSelecteds([...selecteds, contact.id])
      }
    },[selecteds])

    const keyExtractor = useCallback((item, idx) => item.chat_id || idx.toString(), [])

    return (
        <Container>
            <ColumnFlex width="100%">
                <SearchBar
                    value={searchText}
                    placeholder="搜索联系人"
                    style={{
                        backgroundColor: theme.colors?.blockBackground,
                    }}
                    onChange={setSearchText}
                    onClear={() => setSearchText("")}
                />
                <ColumnFlex
                    width="100%"
                    padding="12px"
                    mt="10px"
                    borderRadius="12px"
                    bg={theme.colors.blockBackground}
                >
                   <Text padding="10px 0" fontSize={theme.fontSizes.md} color={theme.colors.text} fontWeight="600">群发消息</Text>
                   <MultiLineTextField
                        value={values.remark}
                        placeholder="输入要群发的消息内容..."
                        maxLength={500}
                        style={{ height: 90  }}
                        onChangeText={(v) => setFieldValue("remark", v)}
                        error={touched.remark && errors.remark}
                    />
                </ColumnFlex>
            </ColumnFlex>
            <ColumnFlex
                flex={1}
                width="100%"
                mt="10px"
                pb={insets.bottom + 40}
                borderRadius="12px"
                overflow="hidden"
            >
                <FlatList
                    data={data}
                    selecteds={selecteds}
                    keyExtractor={keyExtractor}
                    renderItem={({ item, isSelectMode, selecteds }) => {
                        return (
                            <ContactListItem
                                contact={item}
                                selecteds={selecteds}
                                isSelectMode={isSelectMode}
                                onItemClick={onItemClick}
                            />
                        )
                    }}
                />
            </ColumnFlex>
            <CenterFlex
                position="absolute"
                left="12px"
                bottom={insets.bottom}
                width="100%"
                padding="10px 0"
            >
                <Button
                    flex={1}
                    bg={theme.colors.primary}
                    borderRadius="10px"
                    height="40px"
                    loading={loading}
                    disabled={!isActive}
                    onClick={handleSubmit}
                >
                    <Text color={theme.colors.textLight} fontSize={theme.fontSizes.lg} fontWeight="600">
                        发送给{selecteds.length}人
                    </Text>
                </Button>
            </CenterFlex>
        </Container>
      )
}

export default observer(GroupAssistant)
